export default {
	computed: {
		invoices() {
			return this.clientGroup.payerInvoices;
		},
		outstandingInvoices() {
			return _.filter(this.clientGroup.payerInvoices, (invoice) => {
				return invoice.pendingPayment;
			});
		},
		paidInvoices() {
			return _.filter(this.clientGroup.payerInvoices, (invoice) => {
				return invoice.payment;
			});
		},
	},
};
